@if (loaded) {
  <p-multiselect
    [selectAll]="null"
    [filter]="true"
    [options]="carrierList"
    [disabled]="disabled()"
    [ngModel]="carriers"
    (ngModelChange)="carriers = $event; onCarrierChange($event)"
    [maxSelectedLabels]="maxSelectedLabels()"
    placeholder="All"
    selectedItemsLabel="{0} selected"
    appendTo="body"
    dataKey="id"
  >
  </p-multiselect>
}
